(ns app.front.view.admin.domain-groups.upper-tier-groups
  (:require [app.domain.group.model :as group-model]
            [app.domain.municipality.model :as municipality-model]
            [app.front.entities :as entities]
            [app.front.ui.table :as ui-table]
            [app.front.view.admin.domain-groups.municipality-groups :as municipality-groups]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx ::fetch-upper-tier-groups
  (fn [_ _]
    {:comm/command {:command    :admin/upper-tier-municipality-groups
                    :method     :get
                    :on-success [::entities/merge-entity-db]}}))


(rf/reg-sub ::upper-tier-authority-groups
  :<- [::entities/context]
  (fn [ctx _]
    (entities/find-entities ctx {:group/type :group.type/upper-tier-authority})))


(rf/reg-sub ::upper-tier-domain-groups
  :<- [::upper-tier-authority-groups]
  (fn [authority-groups _]
    (->> authority-groups
         (map :entity/parent)
         distinct
         (sort-by :group/name))))


(rf/reg-sub ::lower-tier-planning-groups
  :<- [::entities/context]
  (fn [ctx _]
    (->> (entities/find-entities ctx {:group/type :group.type/application-authority})
         (filter #(contains? (group-model/get-permit-types %) :permit-type/P))
         distinct
         (sort-by :group/name))))


(rf/reg-sub ::upper-tier-domain-id+lower-tier-groups
  :<- [::lower-tier-planning-groups]
  :<- [::upper-tier-authority-groups]
  (fn [[lower-tier-groups upper-tier-ags]]
    (->> lower-tier-groups
         (reduce (fn [acc group]
                   (->> (:group/authority-delegates group)
                        (reduce (fn [acc2 {upper-tier-ag-id :db/id}]
                                  (let [upper-tier-domain-id (some-> upper-tier-ags
                                                                     (p/find-first {:db/id upper-tier-ag-id})
                                                                     :entity/parent
                                                                     :db/id)]
                                    (update acc2 upper-tier-domain-id conj group)))
                                {})
                        (p/deep-merge :into acc)))
                 {}))))


(rf/reg-event-fx ::init
  (fn [_ _]
    {:fx [[:dispatch [::fetch-upper-tier-groups]]
          [:dispatch [::municipality-groups/fetch-municipalities]]]}))


(defn detail-view [tr domain-group]
  [:div.pt-4
   [municipality-groups/municipality-details (util/mmap tr) (:db/id domain-group)]])


(defn existing-groups [tr]
  (let [groups                                 (<sub [::upper-tier-domain-groups])
        upper-tier-domain-id+lower-tier-groups (<sub [::upper-tier-domain-id+lower-tier-groups])
        lang                                   (<sub [:language])]
    [ui-table/modern-responsive-table
     {:items         groups
      :cols          [[:group/name
                       :group/name
                       {:width "20%"
                        :flex  "0"}]
                      [:group/id
                       :group/id
                       {:width "110px"
                        :flex  "0"}]
                      [:admin/authority-groups
                       (fn [group]
                         (->> group
                              :entity/_parent
                              (filter group-model/upper-tier-authority?)
                              (mapv (fn [group]
                                      [:p.p-0
                                       (cc/link {:href       (href/href :view/admin-groups {:group-id (:db/id group)})
                                                 :aria-label (str "Go to " (:group/name group))}
                                                (:group/name group))]))
                              (cons :<>)
                              vec))
                       {:flex "1"}]
                      [:admin/lower-tier-municipalities-authority
                       (fn [group]
                         (->> group
                              :entity/_parent
                              (mapcat group-model/scope-municipalities)
                              distinct
                              (mapv (fn [municipality]
                                      [:p.p-0 (municipality-model/municipality-name municipality lang)]))
                              (cons :<>)
                              vec))
                       {:flex "1"}]
                      [:admin/approval-authority-for
                       (fn [group]
                         (->> (get upper-tier-domain-id+lower-tier-groups (:db/id group))
                              (mapv (fn [group]
                                      [:p.p-0
                                       (cc/link {:href       (href/href :view/admin-groups {:group-id (:db/id group)})
                                                 :aria-label (str "Go to " (:group/name group))}
                                                (:group/name group))]))
                              (cons :<>)
                              vec))
                       {:flex "1"}]
                      [""
                       (fn [group]
                         (cc/button {:icon             i/pen
                                     :size             :small
                                     :kind             :tertiary
                                     :icon-description ""
                                     :on-click         #(>evt [::municipality-groups/edit-municipality-open
                                                               group
                                                               :upper-tier
                                                               (->> (:db/id group)
                                                                    (get upper-tier-domain-id+lower-tier-groups)
                                                                    (map :db/id)
                                                                    set)])}
                                    (tr [:edit])))
                       {:width "130px"
                        :flex  "0"}]]
      :expanded-func (partial detail-view tr)
      :tr            tr}]))


(defn view [_]
  (let [tr      (<sub [:tr])
        domains (<sub [::municipality-groups/lower-tier-domain-groups])]
    [:div.cloudpermit-page.admin-page
     [:div.bx--row.page-heading.justify-between
      [:h1 (tr [:view/admin.upper-tier-municipality-groups])]
      (cc/button {:icon             i/plus
                  :icon-description ""
                  :on-click         #(>evt [::municipality-groups/new-municipality-open :upper-tier])}
                 (tr [:admin/add-municipality]))]
     [:section
      [municipality-groups/new-municipality-modal {:tr tr :domains domains}]
      [existing-groups tr]]]))


(def route
  {:name        :view/admin.upper-tier-municipality-groups
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::init]))}]})
